export type OnboardingState = {
  currentOnboardingModal: OnboardingStep | null;
};

export enum OnboardingStep {
  UserEnergy = 'userEnergy',
}
